import React from 'react';
import PropTypes from 'prop-types';
import { Button, Image, Text, useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { getStaticUrl } from '../../../../../../utils/img';
import MemberCodeSheet from './MemberCodeSheet';

const MemberCodeButton = ({ memberCode }) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        variant="inheritTextButton"
        onClick={onOpen}
        leftIcon={
          <Image
            src={getStaticUrl('web/v1/img/member_center/qr_code.svg')}
            alt=""
            boxSize="16px"
          />
        }
        iconSpacing="2px"
        data-e2e-id="member-code_button"
      >
        <Text
          as="span"
          variant="sectionTitle"
          className="member-center-profile__section-title-text"
          fontSize="12px"
        >
          {t('member_profile.member_code.label')}
        </Text>
      </Button>
      <MemberCodeSheet
        isOpen={isOpen}
        onClose={onClose}
        memberCode={memberCode}
      />
    </>
  );
};

MemberCodeButton.propTypes = {
  memberCode: PropTypes.string.isRequired,
};

export default MemberCodeButton;
